import UTIL_FALCON_UPLOAD_STATE from './state';

const BATCH_KEY = 'STATUS-UPDATE';
const EMPTY_ARRAY = [];

const _getMessages = (messagesByTopic, { topic }) => {
	const topicMeta = messagesByTopic[topic] || {};
	const { messages = [] } = topicMeta || {};
	return messages.filter(m => m?.body?.batch === BATCH_KEY);
}

const _removeAllMessages = (messagesByTopic, { topic }) => {
	const messages = _getMessages(messagesByTopic, { topic });
	let result = messagesByTopic;
	messages.forEach(m => {
		result = UTIL_FALCON_UPLOAD_STATE.deleteMessage(result, { topic, message: m });
	});
	return result;
}

const UTIL_MSG_INITIALIZING_MONITOR = {
	getMessages: _getMessages,
	removeAllMessages: _removeAllMessages,
}

export default UTIL_MSG_INITIALIZING_MONITOR;